"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[848],{

/***/ 92848:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "c": function() { return /* binding */ HeadTags; }
});

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
;// CONCATENATED MODULE: ./src/components/sections/seo-schema/seo-schema.tsx
 // import { Product, Organization, BreadcrumbList } from 'schema-dts';
// type SeoSchema = Product | Organization | BreadcrumbList;



var SeoSchema = function SeoSchema(props) {
  return props.seoData ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("script", {
    type: "application/ld+json",
    dangerouslySetInnerHTML: {
      __html: JSON.stringify(props.seoData)
    }
  }) : null;
};

/* harmony default export */ var seo_schema = (SeoSchema);
;// CONCATENATED MODULE: ../shared/config/global.ts
// Global config file

const global = {
    httpAuth: {
        username: '1',
        password: '1',
    },

    wp: {
        env: {
            prod: { protocol: 'https' },
            stage: { protocol: 'https', subdomain: 'test-wp' },
            test: { protocol: 'http', subdomain: 'test-wp' },
            local: { protocol: 'http', subdomain: 'local' },
        },
    },

    website: {
        env: {
            prod: { protocol: 'https' },
            stage: { protocol: 'http', subdomain: 'test-wp' },
            test: { protocol: 'http', subdomain: 'test-wp' },
            local: { protocol: 'http', subdomain: 'd-local', port: 4241 },
        },
        local: {
            assets: '/website-assets',
            images: '/website-assets/images',
            sentryTagsNode: {
                component: 'BACKEND',
                environment: 'staging',
                brand: '',
            },
        },
        production: {
            assets: '/website-assets',
            images: '/website-assets/images',
            sentryTagsNode: {
                component: 'BACKEND',
                environment: 'staging',
                brand: '',
            },
        },
    },

    mobile: {
        env: {
            prod: { protocol: 'https' },
            stage: { protocol: 'http', subdomain: 'm-stage' },
            test: { protocol: 'http', subdomain: 'm-test' },
            local: { protocol: 'http', subdomain: 'm-local', port: 4240 },
        },
    },

    frontend: {
        env: {
            prod: { protocol: 'https', subdomain: 'frontend' },
            stage: { protocol: 'https', subdomain: 'frontend-staging' },
            test: { protocol: 'http', subdomain: 'frontend.develop.sandbox' },
            local: { protocol: 'http', subdomain: 'local', port: 3000 },
        },
    },
};
const frontend = {
    aws: {
        mobile: {
            aws_project_region: 'eu-central-1',
            aws_appsync_region: 'eu-central-1',
            aws_appsync_authenticationType: 'API_KEY',
            aws_appsync_apiKey: 'da2-f6zedtvklrhmbjwaps42f7xupe',
        },
    },
    logEnabled: true,
    logLevel: 'info',
};
const SCHEMA_CONTEXT = 'http://schema.org';
const website = {};

;// CONCATENATED MODULE: ./src/pages-controller/home-page/seo-schema.ts

var getHomePageSeoSchema = function getHomePageSeoSchema(hostUrl, localeConfig) {
  // Trigger Organization for homepage
  var code = localeConfig.code === 'au' ? 'cruiseaway' : localeConfig.code;
  return {
    '@context': SCHEMA_CONTEXT,
    '@type': 'Organization',
    name: 'Dreamlines',
    url: hostUrl,
    logo: "https://www.".concat(localeConfig.url, "/wp-content/themes/").concat(code, "/images/logos/dreamlines-logo.svg")
  };
};
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/format/index.js + 3 modules
var format = __webpack_require__(32912);
;// CONCATENATED MODULE: ./src/pages-controller/landing-page/seo-schema.ts


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var getProductSeoSchema = function getProductSeoSchema(modulesData, landingPageData) {
  var _cheapestPrice$items$, _cheapestPrice$items$2, _modulesData$cruiseSe, _reviews$aggregation, _reviews$aggregation2;

  var reviews = modulesData === null || modulesData === void 0 ? void 0 : modulesData.ugcData;
  var title = landingPageData === null || landingPageData === void 0 ? void 0 : landingPageData.title;
  var subpage = landingPageData === null || landingPageData === void 0 ? void 0 : landingPageData.subpage;
  var cheapestPrice = modulesData === null || modulesData === void 0 ? void 0 : modulesData.cruiseSearchlandingpageCheapestPrice;
  var lowPrice = Number((((cheapestPrice === null || cheapestPrice === void 0 ? void 0 : (_cheapestPrice$items$ = cheapestPrice.items[0]) === null || _cheapestPrice$items$ === void 0 ? void 0 : (_cheapestPrice$items$2 = _cheapestPrice$items$.sailings) === null || _cheapestPrice$items$2 === void 0 ? void 0 : _cheapestPrice$items$2.minPrice) || 0) / 2).toFixed(0));
  var offerCount = modulesData === null || modulesData === void 0 ? void 0 : (_modulesData$cruiseSe = modulesData.cruiseSearchlandingpageOffer) === null || _modulesData$cruiseSe === void 0 ? void 0 : _modulesData$cruiseSe.totalCount;
  var ratingValue = reviews === null || reviews === void 0 ? void 0 : (_reviews$aggregation = reviews.aggregation) === null || _reviews$aggregation === void 0 ? void 0 : _reviews$aggregation.data.attributes.overall;
  var reviewCount = reviews === null || reviews === void 0 ? void 0 : (_reviews$aggregation2 = reviews.aggregation) === null || _reviews$aggregation2 === void 0 ? void 0 : _reviews$aggregation2.data.attributes.numRatings;
  var seoSchemaData = {
    '@context': SCHEMA_CONTEXT,
    '@type': 'Product',
    name: title
  };
  var lowPriceSeoSchema = {};
  var ratingValueSeoSchema = {};

  if (lowPrice) {
    lowPriceSeoSchema = _objectSpread(_objectSpread({}, seoSchemaData), {}, {
      offers: {
        '@type': 'AggregateOffer',
        offerCount: offerCount,
        lowPrice: lowPrice,
        priceCurrency: 'EUR' //@TODO Fetch the currency dynamically

      }
    });
  }

  if (ratingValue && ratingValue > 0) {
    ratingValueSeoSchema = _objectSpread(_objectSpread({}, seoSchemaData), {}, {
      aggregateRating: {
        "@type": "AggregateRating",
        ratingValue: (ratingValue / 2).toFixed(1),
        reviewCount: reviewCount
      }
    });
  }

  return _objectSpread(_objectSpread(_objectSpread({}, seoSchemaData), lowPriceSeoSchema), ratingValueSeoSchema);
};
var getGoogleRatingSchema = function getGoogleRatingSchema(eventData) {
  return {
    '@context': 'http://schema.org',
    '@type': 'Product',
    name: eventData.title,
    aggregateRating: {
      "@type": "AggregateRating",
      ratingValue: (eventData.ratingValue / 2).toFixed(1),
      reviewCount: eventData.reviewCount
    }
  };
};
var getGoogleEventSchema = function getGoogleEventSchema(eventData) {
  var formattedStartDate = (0,format/* default */.Z)(new Date(eventData.earliestDeparture), 'yyyy-MM-dd');
  var formattedEndDate = (0,format/* default */.Z)(new Date(eventData.latestArrival), 'yyyy-MM-dd');
  return {
    '@context': 'http://schema.org',
    '@type': 'Event',
    name: eventData.title,
    startDate: formattedStartDate,
    endDate: formattedEndDate,
    url: eventData.url,
    location: {
      '@type': 'Place',
      name: eventData.region
    }
  };
};
var getBreadCrumbSeoSchema = function getBreadCrumbSeoSchema(breadcrumbList, hostUrl) {
  var formatBCList = (breadcrumbList === null || breadcrumbList === void 0 ? void 0 : breadcrumbList.length) && breadcrumbList.map(function (_ref, index) {
    var url = _ref.url,
        title = _ref.title;
    return {
      '@type': 'ListItem',
      position: index + 1,
      item: {
        '@id': "".concat(hostUrl).concat(url),
        name: title
      }
    };
  });

  if (formatBCList && formatBCList.length > 0) {
    return {
      '@context': 'http://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: formatBCList
    };
  }

  return null;
};
// EXTERNAL MODULE: ./src/components/sections/landing-breadcrumbs/landing-breadcrumbs.tsx
var landing_breadcrumbs = __webpack_require__(92885);
// EXTERNAL MODULE: ./src/utils/object-keys.ts
var object_keys = __webpack_require__(43711);
// EXTERNAL MODULE: ./src/utils/translation-service.ts
var translation_service = __webpack_require__(21449);
;// CONCATENATED MODULE: ./src/components/sections/head-tags/head-tags.data.ts


function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function head_tags_data_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function head_tags_data_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? head_tags_data_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : head_tags_data_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var getMinPrice = function getMinPrice(modulesData) {
  var _cheapestPrice$items$, _cheapestPrice$items$2;

  var cheapestPrice = modulesData === null || modulesData === void 0 ? void 0 : modulesData.cruiseSearchlandingpageCheapestPrice;
  if (!cheapestPrice) return null;
  var minPrice = Number((((cheapestPrice === null || cheapestPrice === void 0 ? void 0 : (_cheapestPrice$items$ = cheapestPrice.items[0]) === null || _cheapestPrice$items$ === void 0 ? void 0 : (_cheapestPrice$items$2 = _cheapestPrice$items$.sailings) === null || _cheapestPrice$items$2 === void 0 ? void 0 : _cheapestPrice$items$2.minPrice) || 0) / 2).toFixed(0));
  return minPrice ? minPrice.toString() : null;
};

var getMaxDiscount = function getMaxDiscount(modulesData) {
  var _highestDiscount$item, _highestDiscount$item2;

  var highestDiscount = modulesData === null || modulesData === void 0 ? void 0 : modulesData.cruiseSearchlandingpageHighestDiscount;
  if (!highestDiscount) return null;
  var maxDiscount = highestDiscount === null || highestDiscount === void 0 ? void 0 : (_highestDiscount$item = highestDiscount.items[0]) === null || _highestDiscount$item === void 0 ? void 0 : (_highestDiscount$item2 = _highestDiscount$item.sailings) === null || _highestDiscount$item2 === void 0 ? void 0 : _highestDiscount$item2.maxDiscount;
  return maxDiscount ? "".concat((0,translation_service.__)('upTo'), " -").concat(maxDiscount.toString(), "%") : null;
};

var getName = function getName(landingPage) {
  return landingPage.title;
};

var getUGCTotalReviews = function getUGCTotalReviews(modulesData) {
  var _ugcData$aggregation, _ugcData$aggregation$, _ugcData$aggregation$2;

  var ugcData = modulesData["ugcData"];
  var numRatings = ugcData === null || ugcData === void 0 ? void 0 : (_ugcData$aggregation = ugcData.aggregation) === null || _ugcData$aggregation === void 0 ? void 0 : (_ugcData$aggregation$ = _ugcData$aggregation.data) === null || _ugcData$aggregation$ === void 0 ? void 0 : (_ugcData$aggregation$2 = _ugcData$aggregation$.attributes) === null || _ugcData$aggregation$2 === void 0 ? void 0 : _ugcData$aggregation$2.numRatings;
  return numRatings ? numRatings.toString() : null;
};

var getDecks = function getDecks(landingPage, modulesData) {
  var _shipData$factsAndFig;

  var shipData = modulesData["ship".concat(landingPage.id)];
  var decks = shipData === null || shipData === void 0 ? void 0 : (_shipData$factsAndFig = shipData.factsAndFigures) === null || _shipData$factsAndFig === void 0 ? void 0 : _shipData$factsAndFig.decks;
  return decks ? decks.toString() : null;
};

var getPassengerCapacity = function getPassengerCapacity(landingPage, modulesData) {
  var _shipData$factsAndFig2;

  var shipData = modulesData["ship".concat(landingPage.id)];
  var passengerCapacity = shipData === null || shipData === void 0 ? void 0 : (_shipData$factsAndFig2 = shipData.factsAndFigures) === null || _shipData$factsAndFig2 === void 0 ? void 0 : _shipData$factsAndFig2.passengerCapacity;
  return passengerCapacity ? passengerCapacity.toString() : null;
};

var getCabinTotalCategories = function getCabinTotalCategories(landingPage, modulesData) {
  var shipData = modulesData["ship".concat(landingPage.id)];
  var numberOfCabins = shipData === null || shipData === void 0 ? void 0 : shipData.numberOfCabins;
  return numberOfCabins ? numberOfCabins.toString() : null;
};

var getShareImage = function getShareImage(localeConfig) {
  switch (localeConfig.code) {
    case 'au':
      return 'https://images.cruiseaway.com.au/wp-content/uploads/20191128113244/dreamlines.jpg';

    default:
      return 'https://images.dreamlines.de/wp-content/uploads/20191128113244/dreamlines.jpg';
  }
};

var getKeys = function getKeys(landingPage, modulesData) {
  return {
    discount: getMaxDiscount(modulesData),
    maxDiscount: getMaxDiscount(modulesData),
    minPrice: getMinPrice(modulesData),
    name: getName(landingPage),
    ugcTotalReviews: getUGCTotalReviews(modulesData),
    decks: getDecks(landingPage, modulesData),
    passengerCapacity: getPassengerCapacity(landingPage, modulesData),
    numberOfCabins: getCabinTotalCategories(landingPage, modulesData)
  };
};

var getMetaTags = function getMetaTags(props, localeConfig) {
  switch (props.pageType) {
    case 'landingPage':
      {
        var _landingPage$meta;

        var landingPage = props.landingPage,
            modulesData = props.modulesData;
        var subPage = landingPage === null || landingPage === void 0 ? void 0 : landingPage.subpage;
        var subType = subPage === null || subPage === void 0 ? void 0 : subPage.type;

        var subPagesMeta = head_tags_data_objectSpread({}, landingPage === null || landingPage === void 0 ? void 0 : (_landingPage$meta = landingPage.meta) === null || _landingPage$meta === void 0 ? void 0 : _landingPage$meta.subpages);

        var meta = head_tags_data_objectSpread({}, landingPage === null || landingPage === void 0 ? void 0 : landingPage.meta);

        if (meta && subPage && subPage.status && subType) {
          var subPageMeta = subPagesMeta[subType];

          if (subPagesMeta[subType]) {
            var _subPageMeta$title, _subPageMeta$descript;

            meta.title = (_subPageMeta$title = subPageMeta === null || subPageMeta === void 0 ? void 0 : subPageMeta.title) !== null && _subPageMeta$title !== void 0 ? _subPageMeta$title : '';
            meta.description = (_subPageMeta$descript = subPageMeta === null || subPageMeta === void 0 ? void 0 : subPageMeta.description) !== null && _subPageMeta$descript !== void 0 ? _subPageMeta$descript : '';
            meta.canonical = subPage.slug && subPageMeta.canonical ? subPageMeta.canonical : meta.canonical;
          }
        }

        meta.title = dataShortcodeReplacer(meta.title, landingPage, modulesData);
        meta.description = dataShortcodeReplacer(meta.description, landingPage, modulesData);
        meta.og.image.url = getShareImage(localeConfig);
        return meta;
      }

    default:
      var title = props.title,
          description = props.description,
          canonical = props.canonical,
          robots = props.robots,
          og = props.og;
      og.image.url = getShareImage(localeConfig);
      return {
        title: title !== null && title !== void 0 ? title : '',
        description: description !== null && description !== void 0 ? description : '',
        canonical: canonical,
        robots: robots,
        og: og
      };
  }
};
var dataShortcodeReplacer = function dataShortcodeReplacer(text, landingPage, modulesData) {
  var dataKeys = getKeys(landingPage, modulesData);

  var _iterator = _createForOfIteratorHelper((0,object_keys/* objectKeys */.Y)(dataKeys)),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var key = _step.value;
      var replaceText = dataKeys[key] || '';
      text = text.replace("%".concat(key, "%"), replaceText);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return text;
};
var getHeadTagsRequest = function getHeadTagsRequest(args) {
  var request = args.request;
  var includeFilters = {};

  switch (request.mainType) {
    case 'ship':
      {
        request = head_tags_data_objectSpread(head_tags_data_objectSpread({}, request), shipRequest(request));
        includeFilters.shipIds = [String(request.id)];
        break;
      }

    case 'cruiseline':
      {
        includeFilters.brandIds = [String(request.id)];
        break;
      }

    case 'destination':
      {
        includeFilters.regionIds = [String(request.id)];
        break;
      }
  }

  return head_tags_data_objectSpread(head_tags_data_objectSpread(head_tags_data_objectSpread({}, request), highestDiscountRequest(request, includeFilters)), cheapestPriceRequest(request, includeFilters));
};

var shipRequest = function shipRequest(request) {
  var index = request.ships.findIndex(function (item) {
    return item.id === request.id;
  });
  var ship = index === -1 ? {
    id: request.id,
    fields: []
  } : request.ships[index];
  ship.fields.push('numberOfCabins', {
    name: 'factsAndFigures',
    fields: ['passengerCapacity', 'decks']
  });

  if (index === -1) {
    request.ships.push(ship);
  } else {
    request.ships[index] = ship;
  }

  return request;
};

var highestDiscountRequest = function highestDiscountRequest(request, includeFilters) {
  request.cruiseSearches.push({
    name: 'HeadTagsHighestDiscount',
    includeFilters: includeFilters,
    limit: 1,
    sortBy: 'discount',
    fields: [{
      name: 'items',
      fields: [{
        name: 'sailings',
        fields: ['maxDiscount']
      }]
    }]
  });
  return request;
};
var cheapestPriceRequest = function cheapestPriceRequest(request, includeFilters) {
  request.cruiseSearches.push({
    name: 'HeadTagsCheapestPrice',
    includeFilters: includeFilters,
    limit: 1,
    sortBy: 'price_asc',
    fields: [{
      name: 'items',
      fields: [{
        name: 'sailings',
        fields: ['minPrice']
      }]
    }]
  });
  return request;
};
// EXTERNAL MODULE: ./src/contexts/locale-config/locale-config.tsx
var locale_config = __webpack_require__(36097);
// EXTERNAL MODULE: ./src/constants/shipLanding.ts
var shipLanding = __webpack_require__(66603);
// EXTERNAL MODULE: ./src/utils/url-generation.ts
var url_generation = __webpack_require__(46834);
;// CONCATENATED MODULE: ./src/components/sections/head-tags/head-tags.tsx














var getGoogleCruiseEventSchema = function getGoogleCruiseEventSchema(cruise, baseUrl) {
  var _cruise$region, _cruise$region$titles, _cruise$sailings, _cruise$sailings2;

  var formattedRegion = (_cruise$region = cruise.region) === null || _cruise$region === void 0 ? void 0 : (_cruise$region$titles = _cruise$region.titles) === null || _cruise$region$titles === void 0 ? void 0 : _cruise$region$titles.join(',');
  var cruiseData = {
    title: cruise.title,
    earliestDeparture: (_cruise$sailings = cruise.sailings) === null || _cruise$sailings === void 0 ? void 0 : _cruise$sailings.earliestDepartureDate,
    latestArrival: (_cruise$sailings2 = cruise.sailings) === null || _cruise$sailings2 === void 0 ? void 0 : _cruise$sailings2.latestReturnDate,
    region: formattedRegion,
    url: baseUrl
  };
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(seo_schema, {
    seoData: getGoogleEventSchema(cruiseData)
  }, cruise.cruiseId);
};

var HeadTags = function HeadTags(props) {
  var _modulesData$cruiseSe, _reviews$aggregation, _reviews$aggregation2, _meta$og, _meta$og2, _meta$og2$image, _meta$og3, _meta$og3$image, _meta$og4, _meta$og4$image, _meta$og5, _meta$og6, _meta$og7;

  var hostUrl = props.hostUrl,
      landingPage = props.landingPage,
      modulesData = props.modulesData,
      pageType = props.pageType;
  var reviews = modulesData === null || modulesData === void 0 ? void 0 : modulesData.ugcData;
  var localeConfig = react.useContext(locale_config/* LocaleConfigContext */.nO);
  var meta = getMetaTags(props, localeConfig);
  var allowedSubpageTypes = [shipLanding/* SHIP_SUBPAGE_TYPES.POSITION */.vm.POSITION, shipLanding/* SHIP_SUBPAGE_TYPES.CABIN */.vm.CABIN];
  var isShipDetailPage = landingPage.type === shipLanding/* SHIP_PAGE_TYPES.SHIP */.ob.SHIP && !landingPage.subpage.status;
  var isAllowedSubpage = landingPage.subpage.status && allowedSubpageTypes.includes(landingPage.subpage.type || '');
  var hasGoogleEventSchema = isShipDetailPage || isAllowedSubpage;
  var cruises = ((_modulesData$cruiseSe = modulesData.cruiseSearchlandingpageOffer) === null || _modulesData$cruiseSe === void 0 ? void 0 : _modulesData$cruiseSe.items) || [];
  var topThreeEventCruises = (cruises === null || cruises === void 0 ? void 0 : cruises.length) >= 3 ? cruises.slice(0, 3) : [];
  var isReviewsPage = landingPage.subpage.type === shipLanding/* SHIP_SUBPAGE_TYPES.UGC */.vm.UGC;
  var ratingData = {
    title: landingPage === null || landingPage === void 0 ? void 0 : landingPage.title,
    ratingValue: (reviews === null || reviews === void 0 ? void 0 : (_reviews$aggregation = reviews.aggregation) === null || _reviews$aggregation === void 0 ? void 0 : _reviews$aggregation.data.attributes.overall) || 0,
    reviewCount: (reviews === null || reviews === void 0 ? void 0 : (_reviews$aggregation2 = reviews.aggregation) === null || _reviews$aggregation2 === void 0 ? void 0 : _reviews$aggregation2.data.attributes.numRatings) || 0
  };

  var getCruiseUrl = function getCruiseUrl(cruise) {
    var cruiseUrl = (0,url_generation/* generateCruiseUrl */.g)(localeConfig.slugs.cruise.prefix, cruise === null || cruise === void 0 ? void 0 : cruise.title, Number(cruise === null || cruise === void 0 ? void 0 : cruise.cruiseId));
    return hostUrl + cruiseUrl;
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)((head_default()), {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("title", {
        children: meta === null || meta === void 0 ? void 0 : meta.title
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
        name: "description",
        content: meta === null || meta === void 0 ? void 0 : meta.description
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
        property: "og:title",
        content: meta === null || meta === void 0 ? void 0 : meta.title
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
        name: "robots",
        content: (meta === null || meta === void 0 ? void 0 : meta.robots) || 'index, follow'
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
        rel: "canonical",
        href: (meta === null || meta === void 0 ? void 0 : meta.canonical) || hostUrl
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
        property: "og:url",
        content: (meta === null || meta === void 0 ? void 0 : (_meta$og = meta.og) === null || _meta$og === void 0 ? void 0 : _meta$og.url) || hostUrl
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
        property: "og:description",
        content: meta === null || meta === void 0 ? void 0 : meta.description
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
        property: "og:image",
        content: meta === null || meta === void 0 ? void 0 : (_meta$og2 = meta.og) === null || _meta$og2 === void 0 ? void 0 : (_meta$og2$image = _meta$og2.image) === null || _meta$og2$image === void 0 ? void 0 : _meta$og2$image.url
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
        property: "og:image:width",
        content: (meta === null || meta === void 0 ? void 0 : (_meta$og3 = meta.og) === null || _meta$og3 === void 0 ? void 0 : (_meta$og3$image = _meta$og3.image) === null || _meta$og3$image === void 0 ? void 0 : _meta$og3$image.width) || '1200'
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
        property: "og:image:height",
        content: (meta === null || meta === void 0 ? void 0 : (_meta$og4 = meta.og) === null || _meta$og4 === void 0 ? void 0 : (_meta$og4$image = _meta$og4.image) === null || _meta$og4$image === void 0 ? void 0 : _meta$og4$image.height) || '630'
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
        property: "og:type",
        content: (meta === null || meta === void 0 ? void 0 : (_meta$og5 = meta.og) === null || _meta$og5 === void 0 ? void 0 : _meta$og5.type) || 'website'
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
        property: "og:site_name",
        content: (meta === null || meta === void 0 ? void 0 : (_meta$og6 = meta.og) === null || _meta$og6 === void 0 ? void 0 : _meta$og6.siteName) || ''
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
        property: "og:locale",
        content: (meta === null || meta === void 0 ? void 0 : (_meta$og7 = meta.og) === null || _meta$og7 === void 0 ? void 0 : _meta$og7.locale) || 'de_DE'
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
        charSet: "utf-8",
        className: "next-head"
      }, "charSet"), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
        name: "viewport",
        content: "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
      })]
    }), hostUrl && pageType === 'homePage' ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(seo_schema, {
      seoData: getHomePageSeoSchema(hostUrl, localeConfig)
    }) : null, hostUrl && pageType === 'landingPage' ? (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
      children: [isShipDetailPage && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(seo_schema, {
        seoData: getProductSeoSchema(modulesData, landingPage)
      }), isReviewsPage && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(seo_schema, {
        seoData: getGoogleRatingSchema(ratingData)
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(seo_schema, {
        seoData: getBreadCrumbSeoSchema((0,landing_breadcrumbs/* getBreadcrumbsPath */.bp)(landingPage, modulesData, localeConfig), hostUrl)
      }), hasGoogleEventSchema && topThreeEventCruises.map(function (cruise) {
        return getGoogleCruiseEventSchema(cruise, getCruiseUrl(cruise));
      })]
    }) : null]
  });
};

/***/ }),

/***/ 46834:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ generateCruiseUrl; }
/* harmony export */ });
/* harmony import */ var slugify__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31304);
/* harmony import */ var slugify__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(slugify__WEBPACK_IMPORTED_MODULE_0__);

var generateCruiseUrl = function generateCruiseUrl(cruisePathPrefix, cruiseTitle, cruiseId) {
  var selectedSailId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

  if (!cruiseTitle || typeof cruiseTitle !== 'string') {
    // It's only needed cruise page prefix and the cruise id, so if the cruise title is not
    // there we can still create the url
    cruiseTitle = 'cruise';
  }

  var title = slugify__WEBPACK_IMPORTED_MODULE_0___default()(cruiseTitle, {
    lower: true
  }).replace(/[^a-z0-9- ]/g, '');
  return "/".concat(cruisePathPrefix, "/").concat(title, "-").concat(cruiseId).concat(selectedSailId > 0 ? "#selectedSail=".concat(selectedSailId) : '');
};

/***/ })

}]);